/*
 * Copyright © 2015-2017 Serenova, LLC. All rights reserved.
 */

/*
 * MessagingContentArea Messages
 *
 * This contains all the text for the MessagingContentArea component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  endChat: {
    id: 'app.containers.MessagingContentArea.endChat',
    defaultMessage: 'End Chat',
  },
  endWrapup: {
    id: 'app.containers.MessagingContentArea.endWrapup',
    defaultMessage: 'End Wrap Up',
  },
  messagingTemplates: {
    id: 'app.containers.MessagingContentArea.messagingTemplates',
    defaultMessage: 'Messaging Templates',
  },
  toNavigate: {
    id: 'app.containers.MessagingContentArea.toNavigate',
    defaultMessage: 'navigate',
  },
  toSelect: {
    id: 'app.containers.MessagingContentArea.toSelect',
    defaultMessage: 'select',
  },
  esc: {
    id: 'app.containers.MessagingContentArea.esc',
    defaultMessage: 'Esc',
  },
  toDismiss: {
    id: 'app.containers.MessagingContentArea.toDismiss',
    defaultMessage: 'dismiss',
  },
  send: {
    id: 'app.containers.MessagingContentArea.send',
    defaultMessage: 'Send',
  },
  copy: {
    id: 'app.containers.MessagingContentArea.copy',
    defaultMessage: 'Copy',
  },
  copyTranscript: {
    id: 'app.containers.MessagingContentArea.copyTranscript',
    defaultMessage: 'Copy transcript to clipboard',
  },
  copied: {
    id: 'app.containers.MessagingContentArea.copied',
    defaultMessage: 'Copied',
  },
  copiedTranscript: {
    id: 'app.containers.MessagingContentArea.copiedTranscript',
    defaultMessage: 'Copied transcript to clipboard',
  },
  agent: {
    id: 'app.containers.MessagingContentArea.agent',
    defaultMessage: 'Agent',
  },
  customerIsTyping: {
    id: 'app.containers.MessagingContentArea.customerIsTyping',
    defaultMessage: 'Customer is typing',
  },
  customerViewed: {
    id: 'app.containers.MessagingContentArea.customerViewed',
    defaultMessage: 'Customer viewed your message',
  },
});
